/**
 * “Remove Document” confirmation — same ConfirmDialog saveChanges shell as company/property
 * (PMC), with solid primary Delete and grey secondary Cancel.
 */

import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import type { RemoveDocumentConfirmDialogProps } from './RemoveDocumentConfirmDialog.types'

export type { RemoveDocumentConfirmDialogProps } from './RemoveDocumentConfirmDialog.types'

export function RemoveDocumentConfirmDialog({
  isOpen,
  title = 'Remove Document',
  message = 'Please confirm that you really want to remove this default evidence from this case',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  overlayDataTestId,
  primaryButtonDataTestId,
  secondaryButtonDataTestId,
  closeButtonDataTestId,
}: RemoveDocumentConfirmDialogProps) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={title}
      message={message}
      primaryLabel={confirmLabel}
      secondaryLabel={cancelLabel}
      onPrimary={onConfirm}
      onSecondary={onCancel}
      onDismiss={onCancel}
      presentation="saveChanges"
      primaryFirst
      overlayDataTestId={overlayDataTestId}
      primaryButtonDataTestId={primaryButtonDataTestId}
      secondaryButtonDataTestId={secondaryButtonDataTestId}
      closeButtonDataTestId={closeButtonDataTestId}
    />
  )
}
